// import firebase from 'firebase';
import { firebaseInstance as firebase } from '@/main';
import Utils from '@/helpers/Utils';
import DateUtils from '@/helpers/DateUtils';

export default {
  namespaced: true,
  actions: {
    uploadFile: ({ commit }, options) => {
      return new Promise((resolve, reject) => {

        if ((typeof options !== 'object') && (options !== null)) {
          const error = 'uploadFile: options is not a object';
          console.warn(error);
          reject(error);
        }
        if (!options.hasOwnProperty('file') && !options.hasOwnProperty('path')) {
          const error = 'streetView: missing file or bucketPath attributes';
          console.warn(error);
          reject(error);
        }
        if (!options.hasOwnProperty('metaData') && !options.hasOwnProperty('public')) {
          const error = 'streetView: missing \'metaData\' or \'public\' attributes';
          console.warn(error);
          reject(error);
        }
        if ((options.file === undefined) || (options.file === null)) {
          const error = 'file is missing';
          console.warn(error);
          reject(error);
        }
        if ((options.path === undefined) || (options.path === null)) {
          const error = 'path is missing';
          console.warn(error);
          reject(error);
        }
        if ((typeof options.metaData !== 'object') && (options.metaData !== null)) {
          const error = 'uploadFile: metaData is not a object';
          console.warn(error);
          reject(error);
        }
        if ((options.public === undefined) || (options.public === null)) {
          const error = 'public is missing';
          console.warn(error);
          reject(error);
        }

        let defaultMetaData = {
          // cacheControl: 'private',
          contentType: options.file.type
        };

        if (options.metaData !== undefined) {
          defaultMetaData = options.metaData;
        }

        const respExt = Utils.checkExt(options.file);
        const extFileName = respExt.ext;

        const timeStamp = DateUtils.timeStamp();
        const genFileName = `${options.file.name}-${timeStamp}.${extFileName}`;
        const pathStorageFileName = `${options.path}/${genFileName}`;

        const storageService = firebase.storage();
        const storageRef = storageService.ref();

        const uploadTask = storageRef.child(pathStorageFileName).put(options.file, defaultMetaData);

        console.log('new filename and path:', pathStorageFileName);

        uploadTask.on('state_changed', (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload is ${progress.toFixed(2)}% done`);
        }, (error) => {
          console.error('uploadTask Error:', error);
          reject(error);
        }, () => {
          if (options.public === true) {
            console.log('gettin public url');
            uploadTask.snapshot.ref.getDownloadURL()
              .then((downloadURL) => {
                const data = {
                  downloadURL,
                  bucketPath: pathStorageFileName,
                  generatedName: genFileName,
                  company_id: window.localStorage.getItem('company_id') || null,
                  fileRef: uploadTask.snapshot.ref
                };
                resolve(data);
              });
          } else {
            const data = {
              downloadURL: null,
              bucketPath: pathStorageFileName,
              generatedName: genFileName,
              company_id: window.localStorage.getItem('company_id') || null,
              fileRef: uploadTask.snapshot.ref
            };
            resolve(data);
          }
        });
      });
    },
    setMetaData: ({ commit }, fileRef) => {
      //current: Not allowed to set custom metadata for firebaseStorageDownloadTokens
      return new Promise((resolve, reject) => {
        if ((fileRef === undefined) || (fileRef === null)) {
          const error = 'fileRef is missing';
          console.warn(error);
          reject(error);
        }

        const updateMetaData = {
          cacheControl: 'private',
          customMetadata: {
            firebaseStorageDownloadTokens: null
          }
        };

        // Delete the metadata property
        //console.log('Delete the metadata property');
        fileRef.updateMetadata(updateMetaData)
          .then((metadata) => {
            // metadata.contentType should be null
            console.info('metadata updated:', metadata);
            resolve(metadata);
          })
          .catch((error) => {
            // Uh-oh, an error occurred!
            console.error('Uh-oh, an error occurred, while updated metadata!', error);
            reject(error);
          });
      });
    }
  }
};
